import React from 'react';
import { useTranslation } from 'react-i18next';
import SEOHead from '../components/SEOHead';

const TermsOfUse = () => {
  const { t } = useTranslation(['brand', 'legal']);
  const brandName = t('brand.name', { ns: 'brand' });
  const brandAddress = t('brand.address', { ns: 'brand' });
  const brandEmail = t('brand.email', { ns: 'brand' });
  const brandWebsite = t('brand.website', { ns: 'brand' });
  const content = t('terms', { ns: 'legal', returnObjects: true });
  const title = content?.title || 'Terms of Use';
  const effectiveDate = content?.effectiveDate || 'Effective Date: December 2024';
  const sections = Array.isArray(content?.sections) ? content.sections : [];

  const formatText = (value = '') =>
    value
      .replace(/{{brandName}}/g, brandName)
      .replace(/{{brandAddress}}/g, brandAddress)
      .replace(/{{brandEmail}}/g, brandEmail)
      .replace(/{{brandWebsite}}/g, brandWebsite);

  return (
    <>
      <SEOHead page="termsOfUse" />
      <div className='container' style={{ minHeight: '70vh', padding: '80px 0' }}>
        <div className='row'>
          <div className='col-lg-8 mx-auto'>
            <h1 className='title-sub tc mb-5'>{title}</h1>

            <div className='s-48'></div>

            <div style={{ lineHeight: 1.8, fontSize: '16px' }}>
              <p><strong>{effectiveDate}</strong></p>

              {sections.map((section, index) => {
                const HeadingTag = section.level === 4 ? 'h4' : 'h3';
                return (
                  <div key={`${section.heading}-${index}`}>
                    {section.heading && <HeadingTag>{formatText(section.heading)}</HeadingTag>}
                    {Array.isArray(section.paragraphs) &&
                      section.paragraphs.map((paragraph, paragraphIndex) => (
                        <p key={`section-${index}-paragraph-${paragraphIndex}`}>
                          {formatText(paragraph)}
                        </p>
                      ))}
                    {Array.isArray(section.list) && (
                      <ul>
                        {section.list.map((item, itemIndex) => (
                          <li key={`section-${index}-item-${itemIndex}`}>
                            {formatText(item)}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
